(function ($) {
  "use strict";

 AOS.init();
var informationCarousel;

var informationCarouselTimeout;

$('.owl-information').on('mouseenter', function() {
    console.log('STOPPPING!')
    window.clearTimeout(informationCarouselTimeout);
    informationCarousel.trigger('stop.owl.carousel');
})

$('.owl-information').on('mouseleave', function() {
    window.clearTimeout(informationCarouselTimeout);
    informationCarouselTimeout = window.setTimeout(function() {
        console.log('Next!!!')
        informationCarousel.trigger('next.owl.carousel');
    }, 3000)
})

informationCarousel = $('.owl-information');
    informationCarousel.owlCarousel({
  loop:true,
  margin:0,
  nav: false,
  dots: false,
  autoplayTimeout:2000,
  autoplay:true,
  autoplayHoverPause:true,
  responsiveClass:true,
  responsive:{
      0:{
          items:1
      },
      425:{
        items:1,
        dots: false

    },
      768:{
          items:2
      },
      1000:{
          items:4,
          loop:true,
         autoplay:true
      }
  }
});

var informationCarousel2;

var informationCarouselTimeout2;

$('.owl-information-2').on('mouseenter', function() {
    console.log('STOPPPING!')
    window.clearTimeout(informationCarouselTimeout2);
    informationCarousel2.trigger('stop.owl.carousel');
})

$('.owl-information-2').on('mouseleave', function() {
    window.clearTimeout(informationCarouselTimeout2);
    informationCarouselTimeout2 = window.setTimeout(function() {
        console.log('Next!!!')
        informationCarousel2.trigger('next.owl.carousel');
    }, 3000)
})

informationCarousel2 = $('.owl-information-2');
    informationCarousel2.owlCarousel({
  loop:true,
  margin:0,
  nav: false,
  dots: false,
  autoplayTimeout:2000,
  autoplay:true,
  autoplayHoverPause:true,
  responsiveClass:true,
  responsive:{
      0:{
          items:1
      },
      425:{
        items:1,
        dots: false

    },
      768:{
          items:2
      },
      1000:{
          items:2,
          loop:true,
         autoplay:true
      }
  }
});


  
    $(function () {
        $('[data-toggle="popover"]').popover({html:true})
      })

    $('[data-toggle="tooltip"]').tooltip({html:true})
/**********************************************************
 * popup gallery
 * ********************************************************/
baguetteBox.run('.baguetteBox', {
  animation: 'fadeIn',
  noScrollbars: true
});



  // menu fixed js code
  $(window).scroll(function () {
    var window_top = $(window).scrollTop() + 1;
    if (window_top > 100) {
      $('#shopify-section-announcement-bar').addClass('show-top');
    
    } else {
      //$('#shopify-section-announcement-bar').removeClass('display-none');
      $('#shopify-section-announcement-bar').removeClass('show-top');



    }
  });

 
   
  var review = $('.testimonial-carousel');
    review.owlCarousel({
		loop:true,
		nav:false,
        margin:40,
		dots:true,
        autoplayHoverPause: true,
        center: true,
		autoplay: true,
		responsive:{
			0:{
				items:1
			},
			768:{
				items:2
			},
			1000:{
				items:2
			}
		}
	});

  $( ".closeModal" ).click(function() {
    $(".modal_close_category").removeClass("show");
    $(".modal_close_category").style.display= "none";
  });

  // function closeAllModa(){
  //   console.log('probando modal')
  //   let modalClose= document.querySelector('#myModal-2');
  //   modalClose.classList.remove('show');
  // }


}(jQuery));
  

 $(window).on("scroll", function() { 
    var nav = $('.fixed-calendary');
       var nav3 = $('.stt-mars1');

    if ($(this).scrollTop() < 250 ||$(window).scrollTop() + $(window).height() > $(document).height() - 420 ) {
        nav.removeClass("mostrar");
 nav3.css("display", "none");

      }else {
      nav.addClass("mostrar");
            nav3.css("display", "block");

    }
});



$("#social-share").hover(function () {
  $(".social-itens").addClass("open");
  $(".social-itens").removeClass("hidden");
}, 
function () {
    $(".social-itens").removeClass("open");
  $(".social-itens").addClass("hidden");
});



 $(window).on("scroll", function() { 
    var nav = $('#social-share');
    var nav2 = $('.fixed-shop');
    var nav3 = $('.stt-mars1');

    if ($(this).scrollTop() < 250 ||$(window).scrollTop() + $(window).height() > $(document).height() - 420 ) {
        nav.removeClass("mostrar");
        nav2.removeClass("mostrar");
 nav3.css("display", "none");
     // alert("1");
    
      }else {
      nav.addClass("mostrar");
      nav2.addClass("mostrar");
       
        nav3.css("display", "block");

    }
});


/*Efecto contador*/

  let contenedor = document.querySelector(".my-benefits") ;
  let i = 0;
  function iniciar() {
    
  	let scrollTop = document.documentElement.scrollTop;
    let altura = contenedor.offsetTop;
    
    if(altura - 750 < scrollTop && i < 1) {
      
      //alert("hola");
     
    $('.counter').each(function() {
  var $this = $(this),
    countTo = $this.attr('data-count').replace(/,/g, '');

  $({
    countNum: $this.text()
  }).animate({
    countNum: countTo
  }, {
    duration: 8000,
    easing: 'linear',
    step: function() {
      $this.text(numberWithCommas(Math.floor(this.countNum)));
    },
    complete: function() {
      $this.text(numberWithCommas(this.countNum));
    }
  });
});

function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
}

     i = i + 1;

  }
  }
  window.addEventListener('scroll', iniciar);




